import React from 'react';
import { Helmet } from 'react-helmet';
import { Redirect } from 'react-router-dom';
import { getMobileAppLink } from 'helpers';

const DownloadApp = () => {
  window.location.href = getMobileAppLink();

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Redirect to="/" />
    </>
  );
};

export default DownloadApp;
